import axios from 'axios';

const basicApiAxiosConfig = {
  withCredentials: true,
  headers: {
    APP_VERSION: process.env.COMMIT_REF,
    PLATFORM: 'web',
  }, // must be present to avoid axios instance headers leak
};

const api = axios.create({
  ...basicApiAxiosConfig,
  baseURL: `${process.env.REACT_APP_API_URL}/api/v1`,
});

export const addApiInterceptor = (onSuccess, onError) => {
  api.interceptors.response.use(
    (res) => {
      onSuccess && onSuccess(res);

      return Promise.resolve(res);
    },
    (error) => {
      onError && onError(error);

      return Promise.reject(error);
    },
  );
};

const setHeaders = (headers) => {
  api.defaults.headers.common = headers;
};

export const setApiRequestHeaders = (additionalHeaders = {}) => {
  const {
    defaults: {
      headers: { common },
    },
  } = api;

  setHeaders({
    FEMTASY_LOCALE: common['FEMTASY_LOCALE'],
    ...additionalHeaders,
  });
};

export const setApiRequestLocale = (locale) => {
  const {
    defaults: {
      headers: { common },
    },
  } = api;

  setHeaders({ ...common, FEMTASY_LOCALE: locale });
};

const auth = {
  signUp: (payload) => {
    return api.post('/auth', {
      confirm_success_url: '/sign-in',
      ...payload,
    });
  },
  setMarkets: (markets) => {
    return api.put('/profile/markets', { story_markets: markets });
  },
  signUpConfirmation: (credentials) => {
    return api.post('/auth/confirmation', credentials);
  },
  signIn: (email, password) => {
    return api.post('/auth/sign_in', { email, password });
  },
  recoverPassword: (email) => {
    return api.post('/auth/password', { email });
  },
  setNewPassword: (credentials) => {
    return api.put('/auth/password', credentials);
  },
  invalidateToken: () => {
    return api.delete('/auth/sign_out');
  },
  requestNewConfirmationLink: () => {
    return api.get('/auth/confirmation/new');
  },
};

const ageVerification = {
  getToken: (params) => {
    return api.get('/insic_verification', { params });
  },
  getCurrentCountry: () => {
    return axios.get('https://extreme-ip-lookup.com/json/', {
      params: { key: process.env.REACT_APP_EXTREME_IP_LOOKUP_API_KEY },
    });
  },
};

const pin = {
  setPin: (new_pin_code) => {
    return api.post('/pin_codes/create', { new_pin_code });
  },
  updatePin: (pin_code, new_pin_code) => {
    return api.post('/pin_codes/update', { pin_code, new_pin_code });
  },
  verifyPin: (pin_code) => {
    return api.get('/pin_codes/verify', { params: { pin_code } });
  },
};

const endpoints = {
  instance: api,
  ageVerification,
  auth,
  pin,
};

export default endpoints;
